<template>
  <div class="rt-vertical-attr">
    <div class="label">
      {{ label }}
    </div>
    <div class="text">
      <slot>
        {{ text }}
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RtVerticalAttr',
  props: {
    label: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtVerticalAttr.vue?50c79260